import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { DisplayMode } from '../views-components/DisplayMode';
import FormControl from '../views-components/FormControl';
import TextInput from '../views-components/TextInput';
import { useInputProps } from './useInputProps';
import { useSignupData } from './useSignupData';
import styled from 'styled-components';
import { devices } from '../styles/viewports.styles';
import { SLINKY } from 'HubStyleTokens/colors';
const StyledDataInput = styled.div.withConfig({
  displayName: "SignupDataInput__StyledDataInput",
  componentId: "sc-191se8y-0"
})(["min-height:6.8rem;label{font-size:16px;font-weight:400;color:", ";}@media ", "{min-height:7.5rem;}", ""], SLINKY, devices.desktop, props => props.theme.embedded && `min-height: 4.7rem;`);
export const SignupDataInput = /*#__PURE__*/forwardRef(({
  dataKey,
  disabled = false,
  displayMode = DisplayMode.Placeholder,
  customValidationError,
  renderExtraIcons,
  type,
  autoFocus = true,
  help,
  shouldShowPlaceholder = false
}, ref) => {
  const {
    data,
    setData
  } = useSignupData(dataKey);
  const inputProps = useInputProps(dataKey);
  const placeholder = shouldShowPlaceholder ? inputProps.placeholder : '';
  return /*#__PURE__*/_jsx(StyledDataInput, {
    className: `SignupDataInput displayMode-${displayMode}`,
    "data-data-key": dataKey,
    children: /*#__PURE__*/_jsx(FormControl, {
      customValidationError: customValidationError,
      dataKey: dataKey,
      help: help,
      children: /*#__PURE__*/_jsx(TextInput, Object.assign({
        autoFocus: autoFocus,
        disabled: disabled,
        displayMode: displayMode,
        ref: ref,
        renderExtraIcons: renderExtraIcons,
        type: type,
        value: disabled ? '' : data,
        onChange: setData
      }, inputProps, {
        placeholder: placeholder
      }))
    })
  });
});